<!-- eslint-disable max-len -->
<template>
  <div class="main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll">

    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div
          class="bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
        >
          <h5 class="font-bold uppercase text-gray-600">Revenue </h5>
        </div>
        <div class="overflow-y-auto">
          <div style="margin-bottom: 10px">
            <el-row class="px-5 py-2 " >
              <el-col :span="6" class="flex flex-col mr-5">
                <span class="text-left">Filter Date</span>
                <vue-monthly-picker
                  v-model="selectedMonth"
                  :monthLabels="monthLabels"
                  :selectedBackgroundColor="'#1a202c'"
                  :clearOption="false"
                  :max="maxMonth"
                  :min="minMonth"
                  @selected="onChangeDate"
                >
                </vue-monthly-picker>
              </el-col>
              <el-col :span="3" class="flex flex-row mr-5">
                <div class="bg-transparent w-full">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Paid Content</h2>
                      <div class="text-xl text-center text-black font-bold">$200</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="3" class="flex flex-row mr-5">
                <div class="bg-transparent w-full">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Paid Content</h2>
                      <div class="text-xl text-center text-black font-bold">$200</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="3" class="flex flex-row mr-5">
                <div class="bg-transparent w-full">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Paid Content</h2>
                      <div class="text-xl text-center text-black font-bold">$200</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="3" class="flex flex-row mr-5">
                <div class="bg-transparent w-full">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Paid Content</h2>
                      <div class="text-xl text-center text-black font-bold">$200</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="3" class="flex flex-row mr-5">
                <div class="bg-transparent w-full">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Paid Content</h2>
                      <div class="text-xl text-center text-black font-bold">$200</div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
          </data-tables-server>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueMonthlyPicker from 'vue-monthly-picker';
import moment from 'moment';

const displayingItems = 50;

export default {
  name: 'RevenueListPage',
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      selectedMonth: moment(),
      maxMonth: moment(),
      minMonth: moment().subtract(3, 'months'),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'price_credit',
        label: 'Content',
      }, {
        prop: 'price_dollar_text',
        label: 'Category',
      }, {
        prop: 'price_dollar_text',
        label: 'Revenue',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        sortby: 'id',
        sortorder: 'desc',
        month: moment().format('YYYY-MM'),
      },
      monthLabels: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListRevenue(this.filter);
  },
  computed: {
    ...mapGetters('TransactionModule', ['listRevenue']),
  },
  watch: {
    listRevenue: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listRevenue.data !== undefined) {
          this.data = this.listRevenue.data.data.map(credit => ({ ...credit, price_dollar_text: `$${parseFloat(credit.price_dollar).toFixed(2)}` }));
          this.total = this.listRevenue.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('TransactionModule', ['requestListRevenue']),
    async search() {
      await this.requestListRevenue(this.filter);
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        month: moment().format('YYYY-MM'),
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListRevenue(this.filter);
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        month: moment(res).format('YYYY-MM'),
      };
      await this.search();
    },
  },
  components: {
    VueCustomTooltip, VueMonthlyPicker,
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
.vue-daterange-picker .reportrange-text{
  padding: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/RevenueList.vue